/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Welcome/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Welcome({
  children,
  viewPath = "/App/Form/Progress/Welcome"
  
}) {
  return (<React.Fragment
>
<span
  data-testid="Welcome.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
Let's find the best location for your appointment
</span>
{children}
</React.Fragment>)
}